import { useQuery } from "@tanstack/react-query";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import api from "../../../../../utils/api";
import { T_Evento } from "../../../../../components/selects/celula";
import { useState } from "react";
import { PresencaBatismo, Tarefa } from "../../../../../types";
import useLoading from "../../../../../hooks/useLoading";
import { UseGetMembrosParticipantes } from "../../context/getMembros";
import axios from "axios";


const ServicesAlocarBatismo = () => {

  const {
    setMensagemError,
    setMensagemSuccess
  } = useErrorSuccess();

  const { listAll } = UseGetMembrosParticipantes();

  const { startLoading, stopLoading, isLoading } = useLoading()

  const [eventSelected, setEventSelected] = useState<T_Evento>();

  const [tarefas, setTarefas] = useState<Tarefa[]>();

  const [tarefaSelected, setTarefaSelected] = useState<Tarefa>();

  const selectEvent = (value: T_Evento) => setEventSelected(value);

  const resetEvent = () => setEventSelected(undefined);

  const selectTarefa = (value: Tarefa) => setTarefaSelected(value);

  const resetTarefa = () => setTarefaSelected(undefined);

  const { data: batismos } = useQuery({
    queryFn: () => api.get<T_Evento[]>("evento/geral/grupo/1"),
    select: ({data}) => {
      let value = data?.filter(da => da?.ativo)
      let clearValue = value?.reduce((current, prev) => current?.find((el) => el.descricao == prev.descricao) ? current : current?.concat(prev), [])
      return clearValue;
    }
  });

  const getTarefasBatismo = async (event: T_Evento) => {
    selectEvent(event);
    startLoading();
    try {
      const req = await api.get<Tarefa[]>(`evento/tarefa/${event?.id}`);
      const res = await req.data?.filter((tarefa) => tarefa?.descricao?.includes('Aula 1') ||  tarefa?.descricao?.includes('Aula 2') ? false : true);
      setTarefas(res);
      return res
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2));
      return;
    }finally{
      stopLoading()
    }
  };

  const gerarIngressoUsuarioPresentes = async (descNomeAtividadeChecada: keyof PresencaBatismo) => {
    startLoading();
    try {
      let usuariosComPresenca = listAll?.filter((membro) => membro[descNomeAtividadeChecada])
      await axios.all(usuariosComPresenca?.map((usuario) => api.get(`evento/ingresso/gerarparticipantemanual/${tarefaSelected?.id}/${usuario?.usuario}`)))
      setMensagemSuccess('Usuários inseridos no novo evento');
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data));
    } finally {
      stopLoading();
    }
  }

  const gerarIngressoUsuarioFaltantes = async (descNomeAtividadeChecada: keyof PresencaBatismo) => {
    startLoading();
    try {
      let usuariosComPresenca = listAll?.filter((membro) => !membro[descNomeAtividadeChecada])
      await axios.all(usuariosComPresenca?.map((usuario) => api.get(`evento/ingresso/gerarparticipantemanual/${tarefaSelected?.id}/${usuario?.usuario}`)))
      setMensagemSuccess('Usuários inseridos no novo evento');
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data));
    } finally {
      stopLoading();
    }
  }



  return {
    batismos,
    event: {
      selectEvent,
      resetEvent,
      eventSelected
    },
    tarefa: {
      tarefas,
      getTarefasBatismo,
      selectTarefa,
      resetTarefa,
      tarefaSelected
    },
    gerarIngressoUsuarioPresentes,
    gerarIngressoUsuarioFaltantes,
    isLoading
  };
};

export default ServicesAlocarBatismo;
